<template>
  <div class="callback"></div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'
  import { PartnerService } from '../services/partnerService'

  export default {
    name: 'CallbackHandler',
    mounted() {
      this.$auth
        .handleAuthentication(this.$router.currentRoute.query.code)
        .then(async () => {
          const partnerService = new PartnerService(this.$auth)
          const partner = await partnerService.getCurrentPartner()
          await this.setPartnerTheme(partner?.settings ?? {})

          if (this.isCustomerService) {
            this.$router.replace({ name: 'orders' })
          } else {
            this.$router.replace({ name: 'waitingOrders' })
          }
        })
        .catch(() => {
          this.$router.replace({
            name: 'errors',
            params: {
              error: 'notAuthorized',
              displayLogoutBtn: true,
            },
          })
        })
    },
    computed: {
      ...mapState(['isCustomerService']),
    },
    methods: {
      ...mapMutations({
        setPartnerTheme: 'setPartnerTheme',
      }),
    },
  }
</script>
